import React from "react";

const Clock = ({color = "currentColor", ...props}) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.32646 4.75C8.32646 4.3588 8.64359 4.04167 9.03479 4.04167C9.42599 4.04167 9.74312 4.3588 9.74312 4.75V9.70833C9.74312 10.0995 9.42599 10.4167 9.03479 10.4167C8.64359 10.4167 8.32646 10.0995 8.32646 9.70833V4.75Z"
            fill={color}
        />
        <path
            d="M9.03479 10.4167C8.64359 10.4167 8.32646 10.0995 8.32646 9.70833C8.32646 9.31713 8.64359 9 9.03479 9H13.2848C13.676 9 13.9931 9.31713 13.9931 9.70833C13.9931 10.0995 13.676 10.4167 13.2848 10.4167H9.03479Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.03479 17.5C13.7292 17.5 17.5348 13.6944 17.5348 9C17.5348 4.30558 13.7292 0.5 9.03479 0.5C4.34037 0.5 0.53479 4.30558 0.53479 9C0.53479 13.6944 4.34037 17.5 9.03479 17.5ZM9.03479 16.0833C12.9468 16.0833 16.1181 12.912 16.1181 9C16.1181 5.08798 12.9468 1.91667 9.03479 1.91667C5.12277 1.91667 1.95146 5.08798 1.95146 9C1.95146 12.912 5.12277 16.0833 9.03479 16.0833Z"
            fill={color}
        />
    </svg>
);

export default Clock;
